const IS_SERVER = typeof window === 'undefined';

export const setLocalStorageItem = (key: string, item: unknown) => {
  try {
    if (IS_SERVER) {
      console.warn(
        `Tried setting localStorage key “${key}” even though environment is not a client`
      );
      return;
    }

    localStorage.setItem(key, JSON.stringify(item));
    window.dispatchEvent(new StorageEvent('local-storage', { key }));
  } catch (e) {
    console.error('Error setting item in localStorage:', e);
  }
};

export const removeLocalStorageItem = (key: string) => {
  try {
    if (IS_SERVER) {
      console.warn(
        `Tried removing localStorage key “${key}” even though environment is not a client`
      );
      return;
    }

    localStorage.removeItem(key);
    window.dispatchEvent(new StorageEvent('local-storage', { key }));
  } catch (e) {
    console.error('Error removing item from localStorage:', e);
  }
};

export const getLocalStorageItem = <T = unknown>(key: string): T | undefined => {
  try {
    if (IS_SERVER) {
      console.warn(
        `Tried getting localStorage key “${key}” even though environment is not a client`
      );
      return undefined;
    }

    const item = localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : undefined;
  } catch (e) {
    console.error('Error getting item from localStorage:', e);
    return undefined;
  }
};
